import { render, staticRenderFns } from "./ServiceRequestServiceOrderAttendant.vue?vue&type=template&id=45e11114"
import script from "./ServiceRequestServiceOrderAttendant.vue?vue&type=script&lang=js"
export * from "./ServiceRequestServiceOrderAttendant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports